import React from "react";
import { observable, toJS } from "mobx";
import {appendFieldSpan, montarSelectOption, situacaoFormatter, splitBR, listEmailFormatter , dataSortFuncString} from "../../../utils/formatar";
import {buscaFiltrarVazio, buscaSemResultado} from "../../../utils/mensagens";
import {IconeDelete, sortCaret} from "../../comum/components/Icones";
import LoadingImage from "../../comum/components/LoadingImage";
import {Row, Col, Container, FormGroup, Label, Button} from 'reactstrap';
import lscache from "lscache";   

export default class CargaGeralAcompanhamentoStore {
  // Area de inclusão
  @observable inserindo;
  @observable inserindoXls;
  estadoFiltros;
  @observable novasCargas;
  novasCargasLength;
  @observable naviosFiltros;
  @observable loadingNavios;
  @observable colunasN;
  @observable noData;
  @observable itens;
  toShow;
  turn;
  @observable selecionados;
  @observable hasMore;
  @observable cargasLista;
  @observable lista;
  @observable loading;
  @observable tableMessage;
  @observable mockDados;
  @observable inativandoLoading;
  @observable modalInativar;
  @observable outrosDados;
  @observable posEditando;
  @observable listaMensagens;
  @observable salvando;
  @observable sucessoInserirAgendamentos;

  constructor(service) {

    const perfilUsuario = lscache.get('Perfil');
    // Area de inclusão
    this.listaMensagens = false;
    this.posEditando = -1;
    this.inserindo = false;
    this.salvando = false;
    this.inserindoXls = false;
    this.novasCargas = [];
    this.naviosFiltros = false;
    this.loadingNavios = true;
    this.colunasN = this.colunasNovas;
    this.noData = <LoadingImage />;
    this.novasCabotagensLength = 0;
    

  if(lscache.get('Perfil').includes('TRANSPORTADOR CARGA GERAL') || lscache.get('MembershipuserId').includes('325') ){
    this.colunas = this.todasColunasTransportadora;  
  }else{
    this.colunas = this.todasColunas;  
  }

    this.toShow = 20;
    this.turn = 0;
    this.itens = [];
    this.selecionados = [];
    this.hasMore = false;
    this.cargasLista = [];
    this.lista = [];
    this.loading = false;
    this.tableMessage = buscaFiltrarVazio;
    this.estadoFiltros = false;
    this.mockDados = [];
    this.service = service;
    this.inativandoLoading = false;
    this.modalInativar = false;
    this.sucessoInserirAgendamentos = false;
    this.outrosDados = [
      { titulo: "Cliente", field: ["NomeCriador"], id: "F1", hidden: false },
      {
        titulo: "Criado por",
        field: ["UsuarioCriacao"],
        id: "F2",
        hidden: false,
      },
      {
        titulo: "Inativado por",
        field: ["UsuarioCancelamento"],
        id: "F3",
        hidden: false,
      },
      {
        titulo: "Email",
        formatter: listEmailFormatter,
        field: ["EmailCriador"],
        id: "F4",
        hidden: false,
      },
      { titulo: "Observacao", field: ["Observacao"], id: "F5", hidden: false },
    ];
  }

  cancelaInativar = () => {
    this.modalInativar = false;
  };

  abrirModalInativar = () => {
    this.modalInativar = true;
  };

  cancelarEnviar = () => {
    this.novasCargas = [];
    this.novasCargasLength = 0;
  };

  carregarDadosNavio = () => {
    //criar rotina com service depois!
    this.service.listarOperaçoes().then((response) => {
      if (response.data) {
        this.naviosFiltros = montarSelectOption(
          "CvGkey",
          "Name",
          response.data
        );
        this.loadingNavios = false;
      }
    });
  };

  carregarDadosNavioAgend = () => {
    //criar rotina com service depois!
    this.service.listarOperaçoesAgend().then((response) => {
      if (response.data) {
        this.naviosFiltrosAgend = montarSelectOption(
          "CvGkey",
          "Name",
          response.data
        );
        this.loadingNaviosAgend = false;
      }
    });
  };

  listar(filtros) {
    this.estadoFiltros = filtros;
    this.fazerListar(filtros);
  }

  fazerListar = (filtros) => {
    this.selecionados = [];
    this.cargasLista = [];
    this.lista = [];
    this.itens = [];
    this.loading = true;
    this.service
      .listarAcompanhamento(filtros.operacao, filtros.placa, filtros.cpf, filtros.cnh, filtros.dataInicio, filtros.dataFim)
      .then((response) => {
        this.loading = false;
        if (response.data) {
          this.cargasLista = response.data;
        }
        if (this.cargasLista.length === 0) {
          this.tableMessage = buscaSemResultado;
        } else {
          this.tableMessage = buscaFiltrarVazio;
        }
        this.lista = this.cargasLista;

        this.noData = this.tableMessage;
        this.loadFirstTurn();
      });
  };

  reListar = () => {
    this.fazerListar(this.estadoFiltros);
  };

  marcar = (carga) => {
    carga.marcado = !carga.marcado;
    this.selecionados = this.itens.filter((i) => i.marcado === true);
  };

  loadFirstTurn = () => {

    this.itens = this.cargasLista.slice(0, this.toShow);
    this.turn = 1;
    this.hasMore = this.itens.length < this.lista.length;
  };

  loadNextTurn = () => {
    this.itens = [];
    this.itens = this.lista.slice(0, (this.turn + 1) * this.toShow);
    this.turn = this.turn + 1;

    this.hasMore = this.itens.length < this.lista.length;
  };

  marcarTodas = (checked) => {
    this.itens.map((item) => (item.marcado = checked));
    this.selecionados = this.itens.filter((i) => i.marcado === true);
  };

  cancelarInclusao = () => {
    this.inserindo = false;
    this.posEditando = -1;
  };

  incluirCarga = (novaCarga) => {
    if (this.posEditando === -1) {
      if (this.novasCargas.length === 0) this.novasCargasLength = 0;
      novaCarga.pos = this.novasCargasLength;
      this.novasCargasLength++;
      this.novasCargas.push(novaCarga);
    } else {
      this.novasCargas[this.posEditando] = novaCarga;
    }
    this.posEditando = -1;
    this.inserindo = false;
  };

  // Exportar

  getLista() {
    return this.cargasLista;
  }

  getListaCopia() {
    return toJS(this.cargasLista);
  }



  
  

  todasColunas = [
    {
      dataField: "NomeOperacao",
      text: "Navio",
      sort: true,
      style: { maxWidth: "150px", overflowWrap: "break-word" },
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Placa",
      text: "Placa",
      sort: true,
      classes: "chave-cte",
      //style:{maxWidth:'100px', overflowWrap: 'break-word'},
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DriverName",
      text: "Motorista",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DriverLicenseNbr",
      text: "CNH",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DriverCardId",
      text: "CPF",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Razao",
      text: "Cliente",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "PesoLiquido",
      text: "Peso carregado",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DataCarregamento",
      text: "Data de Carregamento",
      sort: true,
      sortCaret: sortCaret,
      sortFunc : dataSortFuncString,
      headerAlign: (column, colIndex) => "left",
    },

    {
      dataField: "DataSaidaString",
      text: "Data de Saida",
      sort: true,
      sortCaret: sortCaret,
      sortFunc : dataSortFuncString,
      headerAlign: (column, colIndex) => "left",
    },  

  ];

  

  todasColunasTransportadora = [
    {
      dataField: "NomeOperacao",
      text: "Navio",
      sort: true,
      style: { maxWidth: "150px", overflowWrap: "break-word" },
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Placa",
      text: "Placa",
      sort: true,
      classes: "chave-cte",
      //style:{maxWidth:'100px', overflowWrap: 'break-word'},
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DriverName",
      text: "Motorista",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DriverLicenseNbr",
      text: "CNH",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DriverCardId",
      text: "CPF",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Razao",
      text: "Cliente",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "ScaleWeight",
      text: "Tara",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "ScaleWeightSaida",
      text: "Peso bruto",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "PesoLiquido",
      text: "Peso carregado",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DataCarregamento",
      text: "Data de Carregamento",
      sort: true,
      sortCaret: sortCaret,
      sortFunc : dataSortFuncString,
      headerAlign: (column, colIndex) => "left",
    },

    {
      dataField: "DataSaidaString",
      text: "Data de Saida",
      sort: true,
      sortCaret: sortCaret,
      sortFunc : dataSortFuncString,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "TvGkey",
      text: "Nº Ticket",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },   
    {
      dataField: "Porao",
      text: "Porão",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },

  ];

  colunasExportacao = [
    {
      dataField: "NomeOperacao",
      text: "Navio",
      sort: true,
      style: { maxWidth: "150px", overflowWrap: "break-word" },
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Placa",
      text: "Placa",
      sort: true,
      classes: "chave-cte",
      //style:{maxWidth:'100px', overflowWrap: 'break-word'},
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DriverName",
      text: "Motorista",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DriverLicenseNbr",
      text: "CNH",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DriverCardId",
      text: "CPF",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },    
    {
      dataField: "Razao",
      text: "Cliente",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "PesoLiquido",
      text: "Peso Carregado",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DataCarregamento",
      text: "Data de Carregamento",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DataSaidaString",
      text: "Data de Saida",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },

  ];

  

  colunasExportacaoTransportadora = [
    {
      dataField: "NomeOperacao",
      text: "Navio",
      sort: true,
      style: { maxWidth: "150px", overflowWrap: "break-word" },
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Placa",
      text: "Placa",
      sort: true,
      classes: "chave-cte",
      //style:{maxWidth:'100px', overflowWrap: 'break-word'},
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DriverName",
      text: "Motorista",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DriverLicenseNbr",
      text: "CNH",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DriverCardId",
      text: "CPF",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    
    {
      dataField: "Razao",
      text: "Cliente",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "ScaleWeight",
      text: "Tara",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "ScaleWeightSaida",
      text: "Peso bruto",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "PesoLiquido",
      text: "Peso Carregado",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DataCarregamento",
      text: "Data de Carregamento",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "DataSaidaString",
      text: "Data de Saida",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "TvGkey",
      text: "Nº Ticket",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },
    {
      dataField: "Porao",
      text: "Porão",
      sort: true,
      sortCaret: sortCaret,
      headerAlign: (column, colIndex) => "left",
    },

  ];


  handleButtonClick = (row) => {
    const indiceDoObjeto = this.novasCargas.findIndex(
      (objeto) => objeto.pos === row.pos
    );
    if (indiceDoObjeto > -1) {
      this.novasCargas.splice(indiceDoObjeto, 1);
    }
  };
}


// WEBPACK FOOTER //
// ./src/modules/carga-geral/stores/CargaGeralAcompanhamentoStore.js